import React, { useState } from 'react';

import ChartOverview from '../chart/chartOverview';
import ChartMuaBanRong from '../chart/chartMuaBanRong';
import ChartForeignBS from '../chart/chartForeignBS';

import PerfectScrollbar from 'react-perfect-scrollbar';

import { numberFormat } from 'utils';
import { StringToDouble } from 'utils';
// import { log } from 'utils';

function PanelOverView({ indexDetail, nnInday, symActive, t, algoIChart }) {
  const [tabNNActive, setTabNNActive] = useState('10-phien');

  // log(indexDetail);

  const _refPrice = indexDetail
    ? StringToDouble(indexDetail?.LastVNIndex)
    : '-';

  return (
    <PerfectScrollbar
      className="mt-2"
      style={{ height: 'calc(100vh - 180px)', marginRight: '-12px' }}
    >
      <div className="w-100" style={{ paddingRight: '12px' }}>
        <div className="w-100">
          <ChartOverview symActive={symActive} algoIChart={algoIChart}/>
        </div>
        <p
          className="txt-content font-weight-bold fz-13 mt-2 mb-0"
          style={{ lineHeight: '14px' }}
        >
          {t('algo.bdkt.txt-overview-2')}
        </p>
        <ul className="list-price-overview">
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-reference-index')}</span>
            <span className="r fz-12 fw-500">{numberFormat(_refPrice, 2)}</span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-Open-Index')}</span>
            <span
              className={
                (indexDetail?.OpenIndex > _refPrice
                  ? 'color-up'
                  : indexDetail?.OpenIndex < _refPrice
                  ? 'color-down'
                  : 'r') + ' fz-12 fw-500'
              }
            >
              {numberFormat(indexDetail?.OpenIndex, 2)}
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-low-high')}</span>
            <span className="txt-content fz-12 fw-500">
              <span
                className={
                  indexDetail?.Lowest > _refPrice
                    ? 'color-up'
                    : indexDetail?.Lowest < _refPrice
                    ? 'color-down'
                    : 'r'
                }
              >
                {numberFormat(indexDetail?.Lowest, 2)}
              </span>{' '}
              -{' '}
              <span
                className={
                  indexDetail?.Highest > _refPrice
                    ? 'color-up'
                    : indexDetail?.Highest < _refPrice
                    ? 'color-down'
                    : 'r'
                }
              >
                {numberFormat(indexDetail?.Highest, 2)}
              </span>
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-trading-volume')}</span>
            <span className="txt-content fz-12 fw-500">
              {numberFormat(indexDetail?.TotalShare)}
            </span>
          </li>
          <li>
            <span className="txt-content fz-12">{t('algo.bdkt.txt-trading-value')}</span>
            <span className="txt-content fz-12 fw-500">
              {numberFormat(indexDetail?.Total / 1000, 2)} {t('algo.bdkt.txt-bil')}
            </span>
          </li>
        </ul>
        <p
          className="txt-content font-weight-bold fz-13 mt-3 mb-2"
          style={{ lineHeight: '14px' }}
        >
          {t('algo.bdkt.txt-foreigner-trading')}
        </p>
        <div
          className="d-grid"
          style={{ gridTemplateColumns: 'auto auto auto', gap: '10px' }}
        >
          <span className="txt-disabled fz-12">{t('algo.bdkt.txt-buy-vol')}</span>
          <span className="txt-disabled fz-12">{t('algo.bdkt.txt-sell-vol')}</span>
          <span className="txt-disabled fz-12">{t('algo.bdkt.txt-net-buy-vol')}</span>
          <span className="color-up fz-12">
            {numberFormat(nnInday?.FGBuyQuantity)}
          </span>
          <span className="color-down fz-12">
            {numberFormat(nnInday?.FGSellQuantity)}
          </span>
          <span
            className={`color-${
              nnInday?.FGBuyQuantity > nnInday?.FGSellQuantity ? 'up' : 'down'
            } fz-12`}
          >
            {numberFormat(nnInday?.FGNetQuantity)}
          </span>
          <span className="txt-disabled fz-12">{t('algo.bdkt.txt-buy-val')}</span>
          <span className="txt-disabled fz-12">{t('algo.bdkt.txt-sell-val')}</span>
          <span className="txt-disabled fz-12">{t('algo.bdkt.txt-net-buy-val')}</span>
          <span className="color-up fz-12">
            {numberFormat(nnInday?.FGBuyValue, 2)} {t('algo.bdkt.txt-bil')}
          </span>
          <span className="color-down fz-12">
            {numberFormat(nnInday?.FGSellValue, 2)} {t('algo.bdkt.txt-bil')}
          </span>
          <span
            className={`color-${
              nnInday?.FGBuyValue > nnInday?.FGSellValue ? 'up' : 'down'
            } fz-12`}
          >
            {numberFormat(nnInday?.FGNetValue, 2)} {t('algo.bdkt.txt-bil')}
          </span>
        </div>

        <div className="my-2 d-flex align-items-center">
          <span className="mr-auto txt-disabled fz-12">{t('algo.bdkt.txt-foreigner-buy-val')}</span>
          <div className="btn-gr-nn-muarong">
            <span
              onClick={() => setTabNNActive('Hom-Nay')}
              className={'fz-13 ' + (tabNNActive === 'Hom-Nay' ? 'active' : '')}
            >
              {t('algo.bdkt.txt-intraday')}
            </span>
            <span
              onClick={() => setTabNNActive('10-phien')}
              className={
                'fz-13 ' + (tabNNActive === '10-phien' ? 'active' : '')
              }
            >
              {t('algo.bdkt.txt-10-day')}
            </span>
          </div>
        </div>
        {tabNNActive === '10-phien' && <ChartMuaBanRong symActive={symActive} />}
        {tabNNActive === 'Hom-Nay' && <ChartForeignBS symActive={symActive} algoIChart={algoIChart}/>}
      </div>
    </PerfectScrollbar>
  );
}

export default PanelOverView;
